import { lazy } from "react";
import Loadable from "../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../constants/enums";
import { CSIO_EDI_ROOT } from "./Business.constants";
import { BusinessCSIOEDocsWrapper } from "./BusinessCSIOEDocs/BusinessCSIOEDocsWrapper";

const CSIOEdiRoot = Loadable(
  lazy(() =>
    import("./CSIOEdiRoot").then(({ CSIOEdiRoot }) => ({
      default: CSIOEdiRoot,
    }))
  )
);
export const CSIOEdiRootRoutes = [
  {
              path: `${CSIO_EDI_ROOT}`,
              exact: true,
              element: (
                <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                  <CSIOEdiRoot />
                </AuthorizedRoute>
              ),
            },
  {
    path: "/business-policy/:customerId/csio-edocs-list/:customerPolicyId/manage-csio-edoc",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessCSIOEDocsWrapper />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/business-policy/:customerId/csio-edocs-list/:customerPolicyId/manage-csio-edoc/:type/:csioEdocsId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessCSIOEDocsWrapper />
      </AuthorizedRoute>
    ),
  },
];
